export default __webpack_public_path__ + "static/media/3040.41e7ba3e.jpg";